"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DisableSftpPgpKeyResponse () {
        return DisableSftpPgpKeyResponse;
    },
    get GenerateSftpPgpKeyResponse () {
        return GenerateSftpPgpKeyResponse;
    },
    get GetSftpPgpKeyResponse () {
        return GetSftpPgpKeyResponse;
    },
    get SftpPgpKeySchema () {
        return SftpPgpKeySchema;
    }
});
const _zod = require("zod");
const SftpPgpKeySchema = _zod.z.object({
    /** Armored public key, for the admin to hand to their source system. */ publicKey: _zod.z.string(),
    /** 1 for a company's first key, incremented on every rotation. */ keyVersion: _zod.z.number().int().positive(),
    createdAt: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ])
});
const GetSftpPgpKeyResponse = _zod.z.object({
    pgpKey: SftpPgpKeySchema.nullable()
});
const GenerateSftpPgpKeyResponse = _zod.z.object({
    pgpKey: SftpPgpKeySchema
});
const DisableSftpPgpKeyResponse = _zod.z.object({
    /** False when there was no active key to disable, so the request was a no-op. */ disabled: _zod.z.boolean()
});
